import { render } from "./MachinesDistributionPage.vue?vue&type=template&id=13e97b99"
import script from "./MachinesDistributionPage.vue?vue&type=script&lang=js"
export * from "./MachinesDistributionPage.vue?vue&type=script&lang=js"

import "./MachinesDistributionPage.vue?vue&type=style&index=0&id=13e97b99&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__